import React, { useState, useEffect } from "react";
import { Input, FormGroup, Label, Button } from "reactstrap";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import { getPlaceListForPrice, getCategories, getStateList } from "../../redux/actions/indexActions";
import { toast } from "react-toastify";
import CKEditor from "react-ckeditor-component";
import Multiselect from "multiselect-react-dropdown";

const AddTourGuide = () => {
    const [cities, setCities] = useState([]);
    const [courseSubSubCategoryOption, setCourseSubSubCategoryOption] = useState([]);
    const [courseSubSubCategory, setCourseSubSubCategory] = useState([]);

    const {
        AuthReducer: { auth },
        indexReducer: { categoriesList, PricePlaceLists, stateLists }
    } = useSelector((state) => state);

    const [formData, setFormData] = useState({
        destination: "",
        name: "",
        email: "",
        mobile: "",
        place_id: "",
        experience: "",
        description: "",
        state: "",
        Language: "",
        status: 1,
        profile_picture: "",
    });

    const [errors, setErrors] = useState({});
    const [text, setText] = useState("");
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const handleText = (e) => {
        const descriptions = e.editor.getData();
        setText(descriptions);
    };

    const inputHandler = (e) => {
        const { name, value } = e.target;
        if (name === "profile_picture") {
            setFormData({ ...formData, [name]: e.target.files[0] });
        }
        if (name === "status") {
            setFormData({ ...formData, [name]: e.target.checked ? 1 : 0 });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };


    useEffect(() => {
        dispatch(getPlaceListForPrice(auth.token));
        dispatch(getStateList(auth.token));
        dispatch(getCategories(auth.token));
    }, [auth]);

    useEffect(() => {
        axios.get(`/api/admin/v1/sub-sub-category-all`, {
            headers: {
                Authorization: `Bearer ${auth.token}`
            }
        }).then((({ data }) => setCourseSubSubCategoryOption(data.data.map((item) => {
            return { name: item.title_english, id: item.id, category_id: item.category_id, sub_category_id: item.sub_category_id }
        })))).catch((err) => console.log(err))
    }, [formData.state_id]);


    const handleSubmit = () => {
        const form = new FormData();
        form.append("destination", formData.destination);
        form.append("name", formData.guide_name);
        form.append("experience", formData.experience);
        form.append("email", formData.email);
        form.append("mobile", formData.mobile);
        form.append("place_id", formData.place_id);
        form.append("Language", formData.Language);
        form.append("description", text);
        form.append("state", formData.state_id);
        form.append("profile_picture", formData.profile_picture);
        form.append("status", formData.status);
        console.log("form data => ", form);
        axios.post(`/api/admin/v1/add-tour-guide`, form, {
            headers: { Authorization: `Bearer ${auth?.token}` },
        }).then((res) => {
            toast.success(res.data?.message);
            navigate(-1);
        }).catch((err) => {
            toast.error(err.response.data);
            setErrors(err.response.data);
        });
    };

    return (
        <div>
            <div className="row my-3">
                <div className="col-md-12">
                    <h4 className="text-white">Add Tour Guide</h4>
                </div>
            </div>
            <div className="bg-white px-3 py-4 rounded-2 my-4">
                <div className="row">
                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label> Category</Label>
                            <Multiselect className="text-black" options={courseSubSubCategoryOption} displayValue="name" onSelect={(val) => {
                                setCourseSubSubCategory(val)
                            }}
                                onRemove={(val) => setCourseSubSubCategory([...val])}
                                labelledBy="Select"
                            />
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label>State <span className="text-danger fs-4">*</span></Label>
                            <Input value={formData?.state_id} type="select" name="state_id" onChange={inputHandler}>
                                <option value="">Select</option>
                                {stateLists?.map?.((item) => {
                                    return (
                                        <option value={item.id} key={item.id}>{item?.state_name}</option>
                                    );
                                })}
                            </Input>
                            <span className="d-block text-danger">{errors?.state_id}</span>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label>Places<span className="text-danger fs-4">*</span></Label>
                            <Input type="select" name="place_id"
                                value={formData.place_id} onChange={inputHandler}>
                                <option value="">Select Place</option>
                                {PricePlaceLists.map((item) => (
                                    <option key={item.id} value={item.id}>
                                        {item.place_name}
                                    </option>
                                ))}
                            </Input>
                            <span className="d-block text-danger">{errors?.place_id}</span>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label>Guide Name <span className="text-danger fs-4">*</span></Label>
                            <Input invalid={Boolean(errors?.guide_name)} value={formData?.guide_name} name="guide_name" onChange={inputHandler} />
                            <span className="d-block text-danger">{errors?.guide_name}</span>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label>Guide Email <span className="text-danger fs-4">*</span></Label>
                            <Input invalid={Boolean(errors?.email)} value={formData?.email} name="email" onChange={inputHandler} />
                            <span className="d-block text-danger">{errors?.guide_name}</span>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label>Guide Mobile <span className="text-danger fs-4">*</span></Label>
                            <Input invalid={Boolean(errors?.mobile)} value={formData?.mobile} name="mobile" onChange={inputHandler} />
                            <span className="d-block text-danger">{errors?.mobile}</span>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label>Upload Profile Picture</Label>
                            <Input type="file" invalid={Boolean(errors?.profile_picture)} name="profile_picture" onChange={(e) =>
                                setFormData((prev) => ({
                                    ...prev,
                                    [e.target.name]: e.target.files[0],
                                }))} />
                            <span className="d-block text-danger">{errors?.profile_picture}</span>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label>Guide Language <span className="text-danger fs-4">*</span></Label>
                            <Input invalid={Boolean(errors?.Language)} value={formData?.Language} name="Language" onChange={inputHandler} />
                            <span className="d-block text-danger">{errors?.Language}</span>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-1">
                        <FormGroup>
                            <Label>Experience <span className="text-danger fs-4">*</span></Label>
                            <Input type="textarea" invalid={Boolean(errors?.experience)} value={formData?.experience} name="experience" onChange={inputHandler} />
                            <span className="d-block text-danger">{errors?.experience}</span>
                        </FormGroup>
                    </div>
                    <div className="col-md-9 offset-md-1">
                        <FormGroup>
                            <Label>Description</Label>
                            <CKEditor content={text} events={{ change: handleText }} />
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-1">
                        <FormGroup switch>
                            <Input type="switch" checked={formData?.status} onChange={inputHandler} name="status" />
                            <Label check>Status</Label>
                        </FormGroup>
                    </div>
                    <div className="col-md-4 offset-md-4">
                        <Button color="primary" onClick={handleSubmit}>Submit</Button>
                        <Button className="ms-3" onClick={() => navigate(-1)}>Cancel</Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddTourGuide;
